import { Flag } from '@fullstory/proto/fs/shared/flags';
import { useFlags } from '@fullstory/react-hooks';
import { useMemo } from 'react';
import { appearancesProperty } from '../contexts';

const defaultOptions: appearancesProperty[] = ['page', 'path', 'host', 'device'];

export const useDefaultAppearancesPropertyOptions = (props?: {
  supportsMobile?: boolean;
  additional: appearancesProperty[];
}): appearancesProperty[] => {
  const flags = useFlags();
  const hasNativeMobile = flags.hasBit(Flag.FeatNativeMobile);
  const { supportsMobile = true, additional } = props || {};

  return useMemo(() => {
    const options: appearancesProperty[] = [...defaultOptions];
    // additional options, if exists, are inserted right after the main appearances page option
    if (additional) {
      options.splice(1, 0, ...additional);
    }
    // if mobile is enabled, screen goes right after page and before additional
    if (hasNativeMobile && supportsMobile) {
      options.splice(1, 0, 'screen');
    }
    return options;
  }, [hasNativeMobile, supportsMobile, additional]);
};
